import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "@phosphor-icons/react";

export type SortOption = 'newest' | 'price_asc' | 'price_desc' | 'year_desc' | 'km_asc';

export interface StockFilters {
  fuel: string;
  sort: SortOption;
}

interface Props {
  filters: StockFilters;
  onChange: (f: StockFilters) => void;
  fuelOptions: string[];
  country?: 'RO' | 'UK' | 'DE';
}

const t = {
  RO: { fuel: 'Combustibil', all: 'Toate', sort: 'Sortează', newest: 'Cele mai noi', priceAsc: 'Preț crescător', priceDesc: 'Preț descrescător', yearDesc: 'An nou → vechi', kmAsc: 'Kilometraj mic', reset: 'Resetează' },
  UK: { fuel: 'Fuel', all: 'All', sort: 'Sort', newest: 'Newest', priceAsc: 'Price low → high', priceDesc: 'Price high → low', yearDesc: 'Year new → old', kmAsc: 'Lowest mileage', reset: 'Reset' },
  DE: { fuel: 'Kraftstoff', all: 'Alle', sort: 'Sortieren', newest: 'Neueste', priceAsc: 'Preis aufsteigend', priceDesc: 'Preis absteigend', yearDesc: 'Jahr neu → alt', kmAsc: 'Wenig Kilometer', reset: 'Zurücksetzen' },
};

export const DealerStockFilters = ({ filters, onChange, fuelOptions, country = 'RO' }: Props) => {
  const txt = t[country] || t.RO;
  const hasActive = filters.fuel !== 'all' || filters.sort !== 'newest';

  return (
    <div className="flex flex-wrap items-center gap-2">
      {fuelOptions.length > 1 && (
        <Select value={filters.fuel} onValueChange={(v) => onChange({ ...filters, fuel: v })}>
          <SelectTrigger className="h-9 w-auto min-w-[140px] rounded-full text-sm">
            <SelectValue placeholder={txt.fuel} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{txt.fuel}: {txt.all}</SelectItem>
            {fuelOptions.map((f) => (
              <SelectItem key={f} value={f}>{f}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      <Select value={filters.sort} onValueChange={(v: SortOption) => onChange({ ...filters, sort: v })}>
        <SelectTrigger className="h-9 w-auto min-w-[160px] rounded-full text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="newest">{txt.newest}</SelectItem>
          <SelectItem value="price_asc">{txt.priceAsc}</SelectItem>
          <SelectItem value="price_desc">{txt.priceDesc}</SelectItem>
          <SelectItem value="year_desc">{txt.yearDesc}</SelectItem>
          <SelectItem value="km_asc">{txt.kmAsc}</SelectItem>
        </SelectContent>
      </Select>

      {hasActive && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onChange({ fuel: 'all', sort: 'newest' })}
          className="h-9 rounded-full text-muted-foreground gap-1"
        >
          <X className="h-3.5 w-3.5" /> {txt.reset}
        </Button>
      )}
    </div>
  );
};
